<template>
  <tabBar style="z-index: 999999" :idIndex="1"></tabBar>
  <CompanyProfile :flag="false"></CompanyProfile>

  <bottom></bottom>
</template>
<script setup>
import tabBar from '@/components/tabBar/tabIndex.vue'
import Bottom from '@/components/bottom/footNavigation.vue'
import CompanyProfile from '@/views/Page/CompanyProfile.vue'
</script>
<style lang="scss" scoped>


//.barPic {
//  height: 750px;
//  width: 100%;
//  // background-color: aquamarine;
//}
//
//
//
//.comTile {
//  height: 50px;
//  width: 100%;
//  display: flex;
//  justify-content: space-between;
//  align-items: flex-end;
//
//  .comTxt {
//    font-size: 52px;
//    font-family: 'Adobe Heiti Std';
//    font-weight: normal;
//    color: #202137;
//  }
//  .comMore {
//    font-size: 21px;
//    font-family: 'Adobe Heiti Std';
//    font-weight: normal;
//    color: #347bd5;
//    cursor: pointer;
//    img {
//      height: 10px;
//    }
//  }
//}
//.content {
//  height: 685px;
//  background: #f7f7f8;
//  box-sizing: border-box;
//  padding: 87px 260px;
//
//  .contentBox {
//    width: 100%;
//    height: 417px;
//    margin-top: 44px;
//    display: flex;
//    .leftText {
//      flex: 1;
//      padding-right: 140px;
//      .textTwo {
//        height: 67px;
//        font-size: 24px;
//        font-family: 'Adobe Heiti Std';
//        font-weight: normal;
//        color: #202137;
//      }
//      .textThree {
//        height: 350px;
//        font-size: 17px;
//        line-height: 29px;
//        font-family: 'Adobe Heiti Std';
//        font-weight: normal;
//        color: #787a87;
//        text-indent: 32px;
//        word-break: break-all;
//        text-overflow: ellipsis;
//        overflow: hidden;
//        display: -webkit-box;
//        -webkit-box-orient: vertical;
//        -webkit-line-clamp: 12; /* 这里是超出几行省略 */
//      }
//    }
//    .right {
//      width: 741px;
//      height: 417px;
//      border-radius: 6px;
//      img {
//        height: 100%;
//        width: 100%;
//      }
//    }
//  }
//}
</style>
